import React from 'react';
import styles from './GatePass.module.css';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { convertToAmPmRange } from './GatePassRequestTable';
import { useState } from 'react';
import axios from 'axios';
import { camelToCapitalized } from 'utils/camelToCapitalized';
import { formatIsoTimeString } from '@fullcalendar/core/internal';
import { X } from 'lucide-react';

export function safeFormatRequestType(value) {
  if (!value || typeof value !== 'string') return 'Not Available (N/A)';

  // Replace underscores with spaces
  const cleaned = value.replace(/_/g, ' ').trim();

  if (!cleaned) return 'Not Available (N/A)';

  // Capitalize each word
  return cleaned.replace(/\b\w/g, (char) => char.toUpperCase());
}

const formatDate = (dateStr) => {
  const [day, month, year] = dateStr.split('-');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const formatted = `${day}-${monthNames[parseInt(month) - 1]}-${year}`;
  return formatted;
};
const formatDateISO = (isoString) => {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const GatePassModal = ({ open, onClose, data = {} }) => {
  const [decodedUser, setDecodedUser] = useState(null);
  const [studentData, setStudentData] = useState([]);
  console.log('gatepass da data', data);

  const fetchStudentData = async () => {
    const token = Cookies.get('Token') || '';
    const response = await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/room/room-detail`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        console.log('Response', response);
        setStudentData(response.data?.data);
      })
      .catch((error) => {
        console.log('Error', error);
        toast.error(error.response.data.message);
      });
  };

  const isGatePassExpired = (data) => {
    const now = getCurrentIST();
    if (!data?.duration) return true;

    if (data.requestType === 'leave') {
      const toDate = parseDDMMYYYYToDate(data.duration.toDate); // custom function
      return now > toDate; // expired if today > toDate
    }

    if (data.requestType === 'Late Entry') {
      const endDateTime = getLateEntryEndDateTime(data.duration);
      return now > endDateTime; // expired if now > actual end datetime
    }

    return false;
  };

  // Convert DD-MM-YYYY to Date object at 23:59 for leaves
  const parseDDMMYYYYToDate = (ddmmyyyy) => {
    const [day, month, year] = ddmmyyyy.split('-').map(Number);
    return new Date(year, month - 1, day, 23, 59, 59);
  };

  // Convert Late Entry duration to full Date object with end time
  const getLateEntryEndDateTime = (duration) => {
    const [day, month, year] = duration.toDate.split('-').map(Number);
    if (!duration.time) {
      // no time => default end of day
      return new Date(year, month - 1, day, 23, 59, 59);
    }
    const [, endTimeStr] = duration.time.split(' - ');
    const [endH, endM] = endTimeStr.split(':').map(Number);
    return new Date(year, month - 1, day, endH, endM);
  };

  const getCurrentIST = () => {
    const now = new Date();
    const istOffset = 5.5 * 60; // IST is UTC+5:30 in minutes
    const localOffset = now.getTimezoneOffset(); // in minutes
    const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60 * 1000);
    return istTime;
  };

  useEffect(() => {
    const encoded = Cookies.get('user');
    if (encoded) {
      try {
        const decoded = decodeURIComponent(encoded);
        setDecodedUser(JSON.parse(decoded));
      } catch (error) {
        console.error('Error decoding user from cookies:', error);
      }
    }
  }, []);
  useEffect(() => {
    console.log('Gate Pass Data:2', data);
    fetchStudentData();
  }, [data]);
  if (!open) return null;

  const {
    name = 'Rahul Kumar Singh',
    time = '9:30 PM - 11:30 PM',
    gatePassId = '#GP0005',
    phone = '+91 98765 43210',
    room = 'B-204',
    category = 'UG',
    reason = 'Weekend trip to hometown',
    startDate = '24-01-2025',
    status = 'Approved and Active'
  } = data;
  const expired = isGatePassExpired(data);

  return (
    <div className={styles.backdrop} role="dialog" aria-modal="true">
      <div
        className={[
          styles.modal,
          data?.requestType === 'early_departure' ? styles.modalGradient2 : '',
          data?.requestType === 'leave' ? styles.modalGradient3 : ''
        ].join(' ')}
      >
        {/* Avatar Circle */}
        {/* <div className={styles.profileCircle}>A</div> */}

        {!expired && (
          <div className={styles.gifContainer}>
            <img src="/gatePassGif.gif" alt="Gate Pass Animation" className={styles.gif} />
          </div>
        )}

        {/* Title */}
        <h2 className={styles.title}>{safeFormatRequestType(data?.requestType) || 'Not Available (N/A)'}</h2>

        {/* Name & Duration */}
        <div className={styles.namecontainer}>
          <div className={styles.row}>
            <div className={styles.label}>Full Name</div>
            <div className={styles.value}>
              {decodedUser.firstName ? `${decodedUser?.firstName} ${decodedUser?.lastName}` : 'Not Available (N/A)'}
            </div>
          </div>
          <div className={styles.row}>
            {(data?.requestType === 'Late Entry' || data?.requestType === 'early_departure') && (
              <>
                <div className={styles.label}>Date</div>
                <div className={styles.value}>{data?.duration?.toDate ? formatDate(data?.duration?.toDate) : 'Not Available (N/A)'}</div>
              </>
            )}
            {data?.requestType === 'leave' && (
              <>
                <div className={styles.label}>Date</div>
                <div className={styles.value}>{data?.duration?.date ? formatDate(data?.duration?.date) : 'Not Available (N/A)'}</div>
              </>
            )}
          </div>
          <div className={styles.row}>
            {data?.requestType === 'leave' && (
              <>
                <div className={styles.label}>Valid Till</div>
                <div className={styles.value}>{data?.duration?.toDate ? formatDate(data?.duration?.toDate) : 'Not Available (N/A)'}</div>
              </>
            )}
            {data?.requestType === 'Late Entry' && (
              <>
                <div className={styles.label}>Time and Duration</div>
                <div className={styles.value}>{convertToAmPmRange(data?.duration?.time) || 'Not Available (N/A)'}</div>
              </>
            )}
            {data?.requestType === 'early_departure' && (
              <>
                <div className={styles.label}>Valid Till</div>
                <div className={styles.value}>{data?.toTime || 'Not Available (N/A)'}</div>
              </>
            )}
          </div>
        </div>

        {/* Status Pill */}
        {expired && <div className={styles.statusPillExpired}>Gate Pass Expired</div>}

        {!expired && <div className={styles.statusPill}>Approved and Active</div>}
        {/* Info Box */}
        <div className={styles.infoBox}>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Gate Pass</span>
            <span className={styles.infoValue}>{data?.requestId ? data?.requestId : 'Not Available (N/A)'}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Phone No.</span>
            <span className={styles.infoValue}>{decodedUser?.phoneNumber ? decodedUser?.phoneNumber : 'Not Available (N/A)'}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Room No.</span>
            <span className={styles.infoValue}>{studentData?.roomNo ? studentData?.roomNo : 'Not Available (N/A)'}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Category</span>
            <span className={styles.infoValue}>{studentData.buildingCategory ? studentData?.buildingCategory : 'Not Available (N/A)'}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>Reason</span>
            <span className={styles.infoValue}>{data.reason ? data?.reason : 'Not Available (N/A)'}</span>
          </div>
          <div className={`${styles.infoRow} ${styles.lastRow}`}>
            {data?.requestType === 'Late Entry' ||
              (data?.requestType === 'early_departure' && (
                <>
                  <span className={styles.infoLabel}>Expiry Date</span>
                  <span className={styles.infoValue}>
                    {data.duration?.toDate ? formatDate(data?.duration?.toDate) : 'Not Available (N/A)'}
                  </span>
                </>
              ))}
            {data?.requestType === 'leave' && (
              <>
                <span className={styles.infoLabel}>Expiry Date</span>
                <span className={styles.infoValue}>
                  {data?.duration?.toDate ? formatDate(data?.duration?.toDate) : 'Not Available (N/A)'}
                </span>
              </>
            )}
          </div>
        </div>

        {/* Bottom Button */}
        {!expired && <div className={styles.footerButton}>Show this pass to the security guard</div>}

        {/* Close Button (Optional) */}
        <button type="button" className={styles.closeBtn} aria-label="Close" onClick={onClose}>
          <X size={24}/>
        </button>
      </div>
    </div>
  );
};

export default GatePassModal;
